<template>
  <v-dialog v-model="dOpenComponente" persistent width="1000px" content-class="">
    <v-card>
      <!-- cabecera del dialogo -->
      <v-toolbar dark class="datModalTitleContainer">
        <v-toolbar-title>
          {{ dInformeComponente.nombre }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="fCerrarVentana()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-form ref="form" lazy-validation>
        <v-card-text>
          <v-flex xs12 class="pl-2 datModalSubtitle mb-3">
            {{ dInformeComponente.descripcion }}
          </v-flex>
          <!-- representantes -->
          <v-layout row wrap justify-space-between>
            <v-flex xs12 px-2>
              <v-text-field color="datPrimary" v-model="dNumeroFactura" :label="this.$t('numeroFactura')"
                autocomplete="off"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4 px-2 v-if="dRole !== 'CLIENTE' && dRole !== 'SUCURSAL'">
              <p class="datLabelGroup pt-0">
                {{ $t('Representante') }}
              </p>
              <DatTextFieldCodeSubfield ref="TablaDeRepresentantes" :pDataPass="dDataRepre" @alert="fAlert"
                @select="fSelectRepre" @clean="fCleanRepre"></DatTextFieldCodeSubfield>
              <v-text-field v-if="dIsChaves" color="datPrimary" id="codAlbaran" :label="this.$t('numeroAlbaranCorto')"
                v-model="dNumAlbaran"></v-text-field>
            </v-flex>

            <!-- clientes -->
            <v-flex xs12 sm6 md4 px-2 v-if="dRole !== 'CLIENTE' && dRole !== 'SUCURSAL'">
              <p class="datLabelGroup pt-0">
                {{ $t('cliente') }}
              </p>
              <template v-if="dRole !== 'MULTISUCURSAL'">
                <DatTextFieldCode ref="TablaDeClientes" :pDataPass="dDataClient" @alert="fAlert" @select="fSelectClient"
                  @clean="fCleanClient"></DatTextFieldCode>
              </template>
              <v-text-field v-if="dIsChaves" color="datPrimary" id="clientRefDat" :label="this.$t('suReferencia')"
                v-model="dReferenciaClte"></v-text-field>
              <template v-if="dRole !== 'SUCURSAL' && !dIsOnPremise">
                <DatTextFieldCode ref="TablaDeSucursal" :pDataPass="dDataSucursal" @select="fSelectSucursal"
                  @clean="fClearSucursal"></DatTextFieldCode>
              </template>
            </v-flex>
            <v-flex v-else>
              <template v-if="dRole !== 'SUCURSAL'">
                <v-flex v-if="dRole !== 'CLIENTE' && dRole !== 'MULTISUCURSAL'" md5 px-2>
                  <DatTextFieldCode ref="TablaDeClientes" :pDataPass="dDataClient" @select="fSelectClient"
                    @clean="fCleanClient" @alert="fAlert"></DatTextFieldCode>
                </v-flex>
                <v-flex md5 px-2>
                  <DatTextFieldCode v-if="!dIsOnPremise" ref="TablaDeSucursal" :pDataPass="dDataSucursal"
                    @select="fSelectSucursal" @clean="fClearSucursal" @alert="fAlert"></DatTextFieldCode>
                </v-flex>
              </template>
            </v-flex>
            <v-flex xs12 sm6 md3 px-2>
              <p class="datLabelGroup pt-0">
                {{ $t('fecha') }}
              </p>
              <v-menu ref="fechaIniMenu" lazy v-model="dDatosFechas.fechaIniMenu" transition="scale-transition" offset-y
                full-width :nudge-right="40" min-width="290px" :close-on-content-click="false">
                <v-text-field clearable required color="datPrimary" slot="activator" :label="this.$t('fechaInicial')"
                  v-model="dDatosFechas.fechaIniDateString" append-icon="event" readonly
                  :rules="[rules.checkfechas]"></v-text-field>
                <v-date-picker :min="dDatosFechas.fechaMinIni" color="datSecondary" v-model="dDatosFechas.fechaIniDate"
                  no-title scrollable :first-day-of-week="1" locale="es-es"
                  @input="$refs.fechaIniMenu.save(dDatosFechas.fechaIniDate)">
                </v-date-picker>
              </v-menu>
              <v-menu ref="fechaFinMenu" v-model="dDatosFechas.fechaFinMenu" lazy transition="scale-transition" offset-y
                full-width :nudge-right="40" min-width="290px" :close-on-content-click="false">
                <v-text-field clearable v-model="dDatosFechas.fechaFinDateString" required color="data-colorcorp1"
                  slot="activator" :label="this.$t('fechaFinal')" append-icon="event" readonly
                  :rules="[rules.checkfechas]"></v-text-field>
                <v-date-picker :min="dDatosFechas.fechaMinFin" v-model="dDatosFechas.fechaFinDate" no-title scrollable
                  :first-day-of-week="1" locale="es-es" @input="$refs.fechaFinMenu.save(dDatosFechas.fechaFinDate)">
                </v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <v-layout row wrap align-center justify-space-between>
            <v-flex xs12 sm1 px-2 ml-auto>
              <v-layout justify-end>
                <v-tooltip v-if="dNotOnPremise" top>
                  <v-btn small slot="activator" class="datSecondaryBtn" flat @click="fDescargarVarios()"
                    :disabled="!dFacturaSeleccionada">
                    <span class="white--text">
                      {{ this.$t('descargarSeleccion') }}
                    </span>
                    <v-icon small right>mdi-file-pdf-box</v-icon>
                  </v-btn>
                  <span>{{ this.$t('descargarSeleccion') }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <v-btn small slot="activator" class="datSecondaryBtnIcon" icon flat @click="fLimpiarFiltros()">
                    <v-icon>mdi-broom</v-icon>
                  </v-btn>
                  <span>{{ $t('limpiar') }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <v-btn small slot="activator" class="datSecondaryBtn" flat @click="fBuscarFacturas()">
                    <span>
                      {{ dBuscarTxt }}
                    </span>
                    <v-icon small right>mdi-magnify</v-icon>
                  </v-btn>
                  <span>{{ dBuscarTxt }}</span>
                </v-tooltip>
              </v-layout>
            </v-flex>
          </v-layout>
          <div class="px-3">
            <v-data-table v-model="dSelected" select-all :rows-per-page-text="dTextNumPag" :headers="dHeaders"
              :items="facturas" item-key="numped" :no-data-text="this.$t('noResultados')"
              :no-results-text="this.$t('noResultados')" v-bind:pagination.sync="dPagination" :loading="dLoading"
              :total-items="dTotalItems" :rows-per-page-items="dRowsPerPageArray" class="mt-1 mb-4">
              <template slot="headers" slot-scope="props">
                <tr class="data-gbGreyLight">
                  <th class="text-xs-center" v-for="header in props.headers" :key="header.text" :id="header.value"
                    :class="[header.value === 'seleccion' ? 'px-2' : '', 'column', (header.sortable) ? 'sortable' : '', dPagination.descending ? 'desc' : 'asc', header.value === dPagination.sortBy ? 'active' : '', 'text-xs-' + header.align]"
                    @click="fCambiaOrden(header)">
                    <template v-if="header.value === 'seleccion'">
                      <v-layout text-xs-center>
                        <v-flex xs12 sm1 px-2 ml-auto mr-auto>
                          <v-checkbox v-if="header.value === 'seleccion'" :input-value="props.all"
                            :indeterminate="props.indeterminate" @click.stop="fToggleAll" v-model="dSelectedAll" primary
                            hide-details></v-checkbox>
                        </v-flex>
                      </v-layout>
                    </template>
                    <template v-else>
                      <v-icon v-if="header.sortable">arrow_upward</v-icon>
                      {{ header.text }}
                    </template>
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <td v-if="dNotOnPremise" class="text-xs-center">
                  <v-layout text-xs-center>
                    <v-flex xs12 sm1 px-2 ml-auto mr-auto>
                      <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
                    </v-flex>
                  </v-layout>
                </td>
                <td class="text-xs-center">{{ props.item.codCli }}</td>
                <td class="text-xs-center">{{ props.item.sucursal }}</td>
                <template v-if="dNotOnPremise" :v-model="dNotOnPremise">
                  <td class="text-xs-center">{{ props.item.nombreCliente }}</td>
                </template>

                <template v-if="!dNotOnPremise" :v-model="dNotOnPremise">
                  <td class="text-xs-center">{{ props.item.nomCli }}</td>
                </template>
                <td class="text-xs-center">{{ props.item.numped }}</td>
                <td class="text-xs-center">{{ formatDate(props.item.fechaPed) }}</td>
                <td class="text-xs-center">{{ formatPrice(props.item.importeTotal) }}</td>
                <td class="text-xs-center">
                  <v-btn flat icon>
                    <v-icon @click="fDownloadReport(props.item)">mdi-file-pdf-box</v-icon>
                  </v-btn>
                  <v-btn v-if="paramsReimpresionFacturas != null && paramsReimpresionFacturas.showBtnDescargaCsv" flat
                    icon>
                    <v-icon @click="fDescargarFacturaExcel(props.item)">mdi-file-excel</v-icon>
                  </v-btn>
                </td>

              </template>
            </v-data-table>
          </div>
        </v-card-text>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>

import { generarPdf, abrirPestanaEnBlanco, abrirPdfEnPestanaPreabierta, downloadZip, cerrarPestana, mensajeErrorWs } from '@/utils/utilDescargarPdf'
import SrvImpresion from '@/services/srv-impresion'
import DatTextFieldCode from '@/components_datadec/DatTextFieldCode'
import DatTextFieldCodeSubfield from '@/components_datadec/DatTextFieldCodeSubfield'

export default {
  name: 'ShpReimpresionFacturas',
  components: {
    DatTextFieldCode,
    DatTextFieldCodeSubfield
  },
  props: {
    pInformeComponente: {
      type: Object,
      required: true
    },
    paramsReimpresionFacturas: {
      type: Object,
      required: false,
      default: null
    },
    pLimitDate: {
      type: Object,
      required: false,
      default: {}
    }
  },
  data() {
    return {
      // Titulo para el componente Dialog
      dTitleLoading: '',

      dBuscarTxt: this.$t('buscar'),
      dLoading: false,
      dPagination: { 'sortBy': 'fechaPed', 'descending': true, 'rowsPerPage': 5 },
      dFilters: [],
      dRowsPerPageArray: [5, 15, 25, 50],
      dRowsPerPage: 5,
      dNumeroFactura: '',
      dNumAlbaran: '',
      dReferenciaClte: '',
      dDataSucursal: {},
      dOpenComponente: true,
      dInformeComponente: null,
      dTotalItems: 0,
      dFirstCharge: 0,
      dTextNumPag: this.$t('factText'),
      dSelectedAll: false,
      dDatosFechas: {
        'fechaIniMenu': false,
        'fechaIniDate': '',
        'fechaIniDateString': '',
        'fechaMinIni': '',
        'fechaFinMenu': false,
        'fechaFinDate': '',
        'fechaFinDateString': '',
        'fechaMinFin': ''
      },
      dNotOnPremise: true,
      dIsOnPremise: localStorage.getItem('isOnPremise') === 'yes',
      dErrorMsgClientIni: [],
      dErrorMsgRepreIni: [],
      dSelectClient: { codigo: '', nombre: '' },
      dSelectSucursal: { sucursal: '', nombreSucursal: '' },
      dRequestClient: { empresa: this.$store.getters.getAutenticacion.empresa },
      dSelectRepre: { codigo: '', subfield: '', nombre: '' },
      dRequestRepre: { empresa: this.$store.getters.getAutenticacion.empresa, pasivo: 'N' },
      dRequestRepreSec: {},
      dRole: '',
      dHeaders: [
        { text: this.$t('seleccion'), value: 'seleccion', sortable: false },
        { text: this.$t('cliente'), align: 'left', value: 'codCli', sortable: true },
        { text: this.$t('sucursal'), align: 'left', value: 'sucursal', sortable: true },
        { text: this.$t('nombre'), align: 'left', value: 'nomCli', sortable: true },
        { text: this.$t('numeroFacturaCorto'), align: 'left', value: 'numped', sortable: true },
        { text: this.$t('fecha'), value: 'fechaPed', sortable: true },
        { text: this.$t('importe'), align: 'right', value: 'importeTotal', sortable: true },
        { text: this.$t('descarga'), value: this.$t('descarga'), sortable: false }
      ],
      dDateFormats: {
        'default': 'DD/MM/YYYY',
        'years': 'YYYY-MM-DD'
      },
      dDataRepre: {},
      dDataClient: {},
      facturas: [],
      rules: {
        /*
         * Regla para comprobar fecha de creacion
         */
        checkfechas: (value) => {
          if ((this.dDatosFechas.fechaIniDateString !== undefined) && (this.dDatosFechas.fechaFinDateString !== undefined) &&
            (this.dDatosFechas.fechaIniDateString !== null) && (this.dDatosFechas.fechaFinDateString !== null) &&
            (this.dDatosFechas.fechaIniDateString !== '') && (this.dDatosFechas.fechaFinDateString !== '')) {
            const fechaIniDate = this.$moment(this.dDatosFechas.fechaIniDateString, this.dDateFormats.default)
            const fechaFinDate = this.$moment(this.dDatosFechas.fechaFinDateString, this.dDateFormats.default)
            if (fechaIniDate <= fechaFinDate) {
              this.fValidateOtherRules()
              return true
            } else {
              return this.$t('fechaInicialMayorFinal')
            }
          } else {
            return true
          }
        }
      },
      dSelected: [],
      dFacturaSeleccionada: false,
      dIsChaves: false
    }
  },
  watch: {
    /*
     * Espera el cambio de la fecha para cambiar el formato
     */
    'dDatosFechas.fechaIniDate': function (val, oldVal) {
      if (val !== null) {
        this.dDatosFechas.fechaIniDateString = this.$moment(val, this.dDateFormats.years).format(this.dDateFormats.default)
      }
    },
    /*
     * Espera el cambio de la fecha para cambiar el formato
     */
    'dDatosFechas.fechaFinDate': function (val, oldVal) {
      if (val !== null) {
        this.dDatosFechas.fechaFinDateString = this.$moment(val, this.dDateFormats.years).format(this.dDateFormats.default)
      }
    },
    /**
     * Comprueba las modificaciones de value
     */
    dPagination: {
      handler() {
        this.dSelectedAll = false
        if (this.dFirstCharge > 0) {
          this.fLoadInvoices(this.dPagination.sortBy, this.dPagination.descending, this.dPagination.page, this.dPagination.rowsPerPage, '', [])
        }
        this.dFirstCharge++
      },
      deep: true
    },
    dSelected: {
      handler() {
        if (this.dSelected.length > 0) {
          this.dFacturaSeleccionada = true
        } else {
          this.dFacturaSeleccionada = false
        }
      }
    },
    dSelectedAll: {
      handler() {
        this.facturas.forEach(item => {
          item.selected = (this.dSelectedAll)
        })
      }
    }
  },
  created() {
    this.fLimitFechas()
    this.fIniciarFechas()
    this.dInformeComponente = this.pInformeComponente
    this.fIniciarVariables()
  },
  methods: {
    fSelectRepre(item) {
      if (item && item != null) {
        this.dSelectRepre.codigo = item.codigo
        this.dSelectRepre.subfield = item.subfield
        this.dSelectRepre.nombre = item.nombre
      }
    },
    fCleanRepre() {
      this.dSelectRepre = []
    },
    fSelectClient(item) {
      if (item && item != null) {
        this.dSelectClient.codigo = item.codigo
        this.dSelectClient.nombre = item.nombre
      }

      if (this.dRoleSelect === "SUCURSAL" && this.dSelectClient.codigo === undefined) {
        this.fCleanClient()
      }

      this.dDataSucursal.client = item.codigo
      this.dDataSucursal.request = {
        empresa: this.$store.getters.getAutenticacion.empresa,
        cliente: item.codigo
      }

      if (item.codigo !== '' && item.codigo !== undefined && this.$refs.TablaDeSucursal !== undefined) {

        this.$refs.TablaDeSucursal.fChangeDisabled(false)
      }
    },
    fCleanClient() {
      if (this.$refs.TablaDeSucursal !== undefined) {

        this.$refs.TablaDeSucursal.fChangeDisabled(true)
        this.$refs.TablaDeSucursal.fClear()
      }
      if (this.$refs.TablaDeClient !== undefined) {
        this.$refs.TablaDeClient.fClean()
      }
      this.fClearSucursal()

      this.dSelectCliente = {}
    },
    fCerrarVentana() {
      this.fLimpiarFiltros()
      this.$emit('close')
    },
    fEventLoading() {
      this.$emit('loading')
      this.dLoading = !this.dLoading
    },
    fIniciarVariables() {
      let isRepre = false
      if (this.fCheckOnPremise()) {
        this.dHeaders = [
          { text: this.$t('cliente'), align: 'left', value: 'codCli', sortable: true },
          { text: this.$t('sucursal'), align: 'left', value: 'sucursal', sortable: true },
          { text: this.$t('nombre'), align: 'left', value: 'nomCli', sortable: true },
          { text: this.$t('numeroFacturaCorto'), align: 'left', value: 'numped', sortable: true },
          { text: this.$t('fecha'), value: 'fechaPed', sortable: true },
          { text: this.$t('importe'), align: 'right', value: 'importeTotal', sortable: true },
          { text: this.$t('descarga'), value: this.$t('descarga'), sortable: false }
        ]
        this.dNotOnPremise = false
      } else {
        this.dHeaders = [
          { text: this.$t('seleccion'), value: 'seleccion', sortable: false },
          { text: this.$t('cliente'), align: 'left', value: 'codCli', sortable: true },
          { text: this.$t('sucursal'), align: 'left', value: 'sucursal', sortable: true },
          { text: this.$t('nombre'), align: 'left', value: 'nombreCliente', sortable: true },
          { text: this.$t('numeroFacturaCorto'), align: 'left', value: 'numped', sortable: true },
          { text: this.$t('fecha'), value: 'fechaPed', sortable: true },
          { text: this.$t('importe'), align: 'right', value: 'importeTotal', sortable: true },
          { text: this.$t('descarga'), value: this.$t('descarga'), sortable: false }
        ]
      }
      this.dRole = this.pLimitDate.roleUser
      if (this.dRole === 'REPRESENTANTE') {
        this.dSelectRepre.codigo = this.$store.getters.getAutenticacion.representante
        this.dSelectRepre.nombre = this.$store.getters.getAutenticacion.representanteNombre
        this.dSelectRepre.subfield = this.$store.getters.getAutenticacion.agente
        isRepre = true
        this.dRequestRepreSec = {
          empresa: this.$store.getters.getAutenticacion.empresa,
          representante: this.$store.getters.getAutenticacion.representante,
          agente: this.$store.getters.getAutenticacion.agente
        }
      }
      if (this.dRole === 'CLIENTE') {
        this.dSelectClient.codigo = this.$store.getters.getAutenticacion.cliente
      }
      this.dDataRepre = {
        'errorMessages': this.dErrorMsgRepreIni,
        'labelMainField': 'codigo',
        'labelSubField': 'agente',
        'label': 'representanteInicial',
        'rowsPerPage': this.dRowsPerPage,
        'headers': [
          { text: this.$t('Representante'), align: 'left', value: 'codigo', column: 'representante' },
          { text: this.$t('agente'), align: 'left', value: 'subfield', column: 'agente' },
          { text: this.$t('nombreRepresentante'), align: 'left', value: 'nombre', column: 'nombre' }
        ],
        'urlWS': 'lovRep',
        'headersSec': [
          { text: this.$t('Representante'), align: 'left', value: 'codigo', column: 'REP_REPRESENTANTE' },
          { text: this.$t('agente'), align: 'left', value: 'subfield', column: 'REP_AGENTE' },
          { text: this.$t('nombreRepresentante'), align: 'left', value: 'nombre', column: 'REP_NOMBRE' }
        ],
        'filtersSec': { 'codigo': 'REP_REPRESENTANTE', 'subfield': 'REP_AGENTE', 'nombre': 'REP_NOMBRE' },
        'defaultSec': { 'codigo': '', 'subfield': '', 'nombre': '' },
        'isSec': isRepre,
        'urlSec': 'getRepres',
        'requestSec': this.dRequestRepreSec,
        'orderByDefaultSec': 'REP_REPRESENTANTE',
        'item': { 'codigo': '', 'subfield': '', 'nombre': '' },
        'request': this.dRequestRepre,
        'filters': { 'codigo': 'representante', 'subfield': 'agente', 'nombre': 'nombre' },
        'resultName': 'dataRes',
        'default': this.dSelectRepre,
        'disabled': false,
        'required': false,
        'title': 'selectRepresentante',
        'isVisibleLoad': true,
        'orderByDefault': 'representante',
        'orderDefault': 'ASC'
      }
      this.dDataClient = {
        'errorMessages': this.dErrorMsgClientIni,
        'label': 'clienteInicial',
        'rowsPerPage': this.dRowsPerPage,
        'headers': [
          { text: this.$t('cliente'), align: 'left', value: 'codigo', column: 'cliente' },
          { text: this.$t('nombreCliente'), align: 'left', value: 'nombre', column: 'nombre' }
        ],
        'urlWS': 'lovClte',

        'item': { 'codigo': '', 'nombre': '' },
        'filters': { 'codigo': 'cliente', 'nombre': 'nombre' },
        'resultName': 'dataRes',
        'request': this.dRequestClient,
        'default': this.dSelectClient,
        'disabled': false,
        'required': false,
        'orderByDefault': 'cliente',
        'orderDefault': 'ASC',
        'isVisibleLoad': true,
        'textCodigo': 'codigo',
        'title': 'seleccionaUnCliente'
      }
      this.dDataSucursal = {
        'errorMessages': [],
        'label': this.$t('sucursal'),
        'rowsPerPage': 10,
        'headers': [
          { text: this.$t('sucursal'), align: 'left', value: 'codigo', column: 'sucursal' },
          { text: this.$t('nombreSucursal'), align: 'left', value: 'nombre', column: 'razonSocial' }
        ],
        'urlWS': 'lovDic',

        'item': { 'codigo': '', 'nombre': '' },
        'filters': { 'codigo': 'sucursal', 'nombre': 'razonSocial' },
        'resultName': 'dataRes',
        'request': null,
        'default': this.dSelectSucursal,
        'disabled': true,
        'required': true,
        'orderByDefault': 'sucursal',
        'orderDefault': 'sucursal',
        'isVisibleLoad': true,
        'textCodigo': 'codigo',
        'title': this.$t('seleccionaUnaSucursal'),
        'client': this.dSelectClient.codigo
      }

      if (this.pLimitDate.roleUser === 'CLIENTE' || this.pLimitDate.roleUser === 'MULTISUCURSAL') {
        this.dDataSucursal.disabled = false
        this.dDataSucursal.request = {
          empresa: this.$store.getters.getAutenticacion.empresa,
          cliente: this.$store.getters.getAutenticacion.cliente
        }
      }

      if (localStorage.getItem('isOnPremise') === 'yes' && (localStorage.getItem('headerDomain') === 'CHAVES' || localStorage.getItem('headerDomain') === 'CHAVESPR')) {
        this.dIsChaves = true
      }
    },
    /**
     * valida el resto de reglas
     */
    fBuscarFacturas() {
      if (this.fValidateOtherRules()) {
        if (this.fCheckFiltrosPendientes()) {
          this.fLoadInvoices(this.dPagination.sortBy, this.dPagination.descending, this.page, this.dPagination.rowsPerPage, '', [])
        } else {
          this.dBuscarTxt = this.$t('buscar')
          this.$emit('alert', '<b>' + this.$t('avisoFactura') + '</b><br/>' + this.$t('avisoFacturaDesc'))
        }
      } else {
        this.dBuscarTxt = this.$t('buscar')
        this.$emit('alert', '<b>' + this.$t('reviseFiltrosBuscar') + '</b>')
      }
    },
    /**
     * valida el resto de reglas
     */
    fValidateOtherRules() {
      return this.dErrorMsgClientIni.length === 0 && this.dErrorMsgRepreIni.length === 0
    },
    /**
     * comprueba si falta recibir información de algun filtro
     */
    fCheckFiltrosPendientes() {
      switch (this.dRole) {
        case 'SUCURSAL':
          this.dSelectClient.codigo = this.$store.getters.getAutenticacion.cliente
          this.dSelectSucursal.sucursal = this.$store.getters.getAutenticacion.sucursal
          return true
        case 'CLIENTE':
          this.dSelectClient.codigo = this.$store.getters.getAutenticacion.cliente
          return true
        case 'REPRESENTANTE':
          this.dSelectRepre.codigo = this.$store.getters.getAutenticacion.representante
          return true
        default:
          return (this.fNotEmpty(this.dSelectRepre.codigo) || this.fNotEmpty(this.dSelectClient.codigo))
      }
    },
    fCheckOnPremise() {
      return localStorage.getItem('isOnPremise') === 'yes'
    },
    /**
     * Metodo de limpieza de los filtros
     */
    fLimpiarFiltros() {
      // Limpia desplegables
      this.dErrorMsgClientIni = []
      this.dErrorMsgRepreIni = []
      if (this.dRole === 'ADMIN') {
        this.dSelectRepre = { codigo: '', nombre: '' }
        if (this.$refs.TablaDeRepresentantes) {
          this.$refs.TablaDeRepresentantes.fActualizarItem(this.dSelectRepre)
        }
      }
      if (this.dRole === 'ADMIN' || this.dRole === 'REPRESENTANTE') {
        this.dSelectClient = { codigo: '', nombre: '' }
        if (this.$refs.TablaDeClientes) {
          this.$refs.TablaDeClientes.fActualizarItem(this.dSelectClient)
        }
      }
      // Limpia fechas
      this.dDatosFechas.fechaIniMenu = false
      this.dDatosFechas.fechaIniDate = null
      this.dDatosFechas.fechaIniDateString = null
      this.dDatosFechas.fechaFinMenu = false
      this.dDatosFechas.fechaFinDate = null
      this.dDatosFechas.fechaFinDateString = null
      // limpia search
      this.dNumeroFactura = ''
      this.dNumAlbaran = ''
      this.dReferenciaClte = ''
      //
      this.facturas = []
      this.dTotalItems = 0
      this.dPagination = { 'sortBy': 'fechaPed', 'descending': true, 'rowsPerPage': 5 }
    },
    /*
     * cambia el orden de an columna
     */
    fCambiaOrden(header) {
      if (header.sortable) {
        const column = header.value
        this.dPagination.page = 1
        this.dPagination.rowsPerPage = this.dRowsPerPage
        if (this.dPagination.sortBy === column) {
          this.dPagination.descending = !this.dPagination.descending
        } else {
          this.dPagination.sortBy = column
          this.dPagination.descending = false
        }
      }
    },
    /*
     * Metodo de carga de usuarios
     */

    fAddFilters(jsonEntrada) {
      const isValid = (val) => val !== undefined && val !== null && val !== ''
      if (this.dSelectRepre) {
        if (isValid(this.dSelectRepre.codigo)) {
          jsonEntrada.representanteInicial = this.dSelectRepre.codigo
          jsonEntrada.representanteFinal = this.dSelectRepre.codigo
        }

        if (localStorage.getItem('isOnPremise') !== 'yes' && isValid(this.dSelectRepre.subfield)) {
          const agente = this.dSelectRepre.subfield
          const authAgente = this.$store.getters.getAutenticacion.agente
          if ((this.dRole === 'REPRESENTANTE' && authAgente !== agente && agente !== 0) ||
            (this.dRole === 'ADMIN' && agente !== 0)) {
            jsonEntrada.agenteInicial = agente
            jsonEntrada.agenteFinal = agente
          }
        }
      }

      if (this.dSelectClient && isValid(this.dSelectClient.codigo)) {
        jsonEntrada.clienteInicial = this.dSelectClient.codigo
        jsonEntrada.clienteFinal = this.dSelectClient.codigo
      }

      if (isValid(this.dDatosFechas.fechaIniDateString)) {
        jsonEntrada.fechaIni = this.dDatosFechas.fechaIniDateString
      } else if (isValid(this.dDatosFechas.fechaMinIni)) {
        jsonEntrada.fechaIni = this.$moment(this.dDatosFechas.fechaMinIni, this.dDateFormats.years).format(this.dDateFormats.default)
      }

      if (isValid(this.dDatosFechas.fechaFinDateString)) {
        jsonEntrada.fechaFin = this.dDatosFechas.fechaFinDateString
      } else if (isValid(this.dDatosFechas.fechaMinFin)) {
        jsonEntrada.fechaFin = this.$moment(this.dDatosFechas.fechaMinFin, this.dDateFormats.years).format(this.dDateFormats.default)
      }

      if (isValid(this.dNumeroAlbaran)) {
        jsonEntrada.codigosDocumento = [{ codigoDocumento: this.dNumeroAlbaran }]
      }

      if (isValid(this.dSelectSucursal)) {
        jsonEntrada.sucursal = this.dSelectSucursal.codigo
      }

      if (this.dRole === 'SUCURSAL') {
        const auth = this.$store.getters.getAutenticacion
        jsonEntrada.clienteInicial = auth.cliente
        jsonEntrada.clienteFinal = auth.cliente
        jsonEntrada.sucursal = JSON.parse(localStorage.getItem('datos-autenticacion')).sucursal
      }

      if (this.dNumeroFactura) {
        jsonEntrada.codigosDocumento = [{ "codigoDocumento": this.dNumeroFactura }];
      }
    },
    fLoadInvoices(sortBy, descending, page, rowsPerPage, search, filters) {
      this.fEventLoading()
      this.dFilters = filters
      let offset = 1

      if (this.dRole === 'CLIENTE') {
        this.dSelectClient.codigo = this.$store.getters.getAutenticacion.cliente
      }

      descending = (descending) ? 'DESC' : 'ASC'
      page = (page === undefined) ? 1 : page
      rowsPerPage = (rowsPerPage === undefined) ? this.dPagination.rowsPerPage : rowsPerPage
      filters = (filters === undefined) ? [] : filters

      if (sortBy === undefined) {
        sortBy = 'fechaPed'
        descending = 'DESC'
      }

      offset = this.dPagination.rowsPerPage * (page - 1) + 1

      // revisar la carga de datos y las columnas
      const jsonEntrada = {
        tira: this.$store.getters.getAutenticacion.tira,
        usuario: this.$store.getters.getAutenticacion.usuario,
        empresa: this.$store.getters.getAutenticacion.empresa,
        tipoConta: '0',
        tiposDocBusqueda: [{ tipoDocumento: 'F' }],
        search: search,
        offset: offset,
        numRows: rowsPerPage,
        orderBy: sortBy,
        order: descending,
        filters: filters
      }

      // Función Add Filtros
      this.fAddFilters(jsonEntrada)
      if (this.dRole === 'SUCURSAL') {
        jsonEntrada.sucursal = this.$store.getters.getAutenticacion.sucursal
      }
      if (jsonEntrada.fechaFin !== '' && jsonEntrada.fechaIni !== '') {
        SrvImpresion.fRecuperarDocumentoCab(jsonEntrada).then((response) => {
          if (response.data.documentosCab !== null && response.data.documentosCab !== undefined) {
            this.facturas = response.data.documentosCab
          } else if (response.data.dataRes !== null && response.data.dataRes !== undefined) {
            this.facturas = response.data.dataRes
          }

          if (response.data.totalRows && response.data.totalRows !== null) {
            this.dTotalItems = response.data.totalRows
          } else if (response.data.numReg && response.data.numReg !== null) {
            this.dTotalItems = response.data.numReg
          } else {
            this.dTotalItems = response.data.rownum
          }
          this.fEventLoading()
          this.numValidacionesValue = 0
          this.dBuscarTxt = this.$t('buscar')
        }).catch(error => {
          this.fErrorComprobado(error.response)
        })
      } else {
        this.fEventLoading()
        this.$emit('alert', '<b>' + this.$t('notValidDate') + '</b><br>' + this.$t('notValidDateDesc'))
      }
    },
    /**
     * Busca el role del usuarios para ver que ha de mostrar
     */
    formatPrice(value) {
      const spanishFormatter = new Intl.NumberFormat('de-DE')
      return spanishFormatter.format(value)
    },
    fIniciarFechas() {
      const dateIni = new Date()
      dateIni.setDate(dateIni.getDate() - 7)

      let mes = this.fPadTo2Digits(dateIni.getMonth() + 1)
      let dia = this.fPadTo2Digits(dateIni.getDate())
      if (this.dDatosFechas.fechaMinIni !== '') {
        const dateIniFechaRol = new Date(this.dDatosFechas.fechaMinIni)
        dateIniFechaRol.setHours(0, 0, 0, 0)
        if (dateIniFechaRol <= dateIni) {
          this.dDatosFechas.fechaIniDateString = dia + '/' + mes + '/' + dateIni.getFullYear()
        } else {
          const dateNow = new Date()
          dateNow.setHours(0, 0, 0, 0)
          const dateInTime = dateNow.getTime() - dateIniFechaRol.getTime()
          this.dDiasAnteriores = dateInTime / (1000 * 3600 * 24)
          this.dDatosFechas.fechaIniDateString = this.$moment(this.dDatosFechas.fechaMinIni, this.dDateFormats.years).format(this.dDateFormats.default)
        }
      } else {
        this.dDatosFechas.fechaIniDateString = dia + '/' + mes + '/' + dateIni.getFullYear()
      }
      const dateFin = new Date()
      mes = this.fPadTo2Digits(dateFin.getMonth() + 1)
      dia = this.fPadTo2Digits(dateFin.getDate())
      if (this.dDatosFechas.fechaMinFin !== '') {
        const dateFinFechaRol = new Date(this.dDatosFechas.fechaMinFin)
        if (dateFinFechaRol <= dateFin) {
          this.dDatosFechas.fechaFinDateString = dia + '/' + mes + '/' + dateFin.getFullYear()
        } else {
          this.dDatosFechas.fechaFinDateString = this.$moment(this.dDatosFechas.fechaMinFin, this.dDateFormats.years).format(this.dDateFormats.default)
        }
      } else {
        this.dDatosFechas.fechaFinDateString = dia + '/' + mes + '/' + dateFin.getFullYear()
      }
    },
    fPadTo2Digits(num) {
      return num.toString().padStart(2, '0')
    },
    /**
     * Metodo de descarga del informes
     */
    fDownloadReport(factura) {
      // prepara los parametros generales de busqueda
      const ventanaPdf = abrirPestanaEnBlanco()
      this.fEventLoading()

      let serieTemp = factura.numped.substring(0, factura.numped.length - 6)
      let dFacturaTemp = String(Number(factura.numped.substr(factura.numped.length - 6)))

      if (factura.serie !== null && factura.serie !== undefined && factura.secuencia !== null && factura.secuencia !== undefined) {
        serieTemp = factura.serie
        dFacturaTemp = factura.secuencia
      } else if (factura.numero !== null && factura.numero !== undefined) {
        dFacturaTemp = factura.numero
      }

      const jsonEntrada = {
        tira: this.$store.getters.getAutenticacion.tira,
        empresa: String(this.$store.getters.getAutenticacion.empresa),
        tipoEmpresa: '0',
        pdfSn: 'S',
        rpteIni: String(factura.representante),
        rpteFin: String(factura.representante),
        //        series: [{serie: serieTemp}],
        clteIni: String(factura.codCli),
        clteFin: String(factura.codCli),
        fechaIni: this.formatDate(factura.fechaPed),
        fechaFin: this.formatDate(factura.fechaPed),
        factFin: dFacturaTemp,
        factIni: dFacturaTemp
      }

      if (serieTemp !== null && serieTemp !== undefined && serieTemp !== 'null' && serieTemp.length > 0) {
        const series = [{ serie: serieTemp }]
        jsonEntrada.series = series
      }
      SrvImpresion.getURLFacturas(jsonEntrada).then(response => {
        // El servicio resuelve con el objeto de error de axios cuando la peticion falla (sin "data" en la raiz)
        const datos = (response && response.data) ? response.data : null
        if (datos && datos.statusCode === '200') {
          if (datos.report) {
            abrirPdfEnPestanaPreabierta(generarPdf(datos.report), ventanaPdf)
          } else {
            cerrarPestana(ventanaPdf)
            this.$emit('alert', '<b>' + this.$t('notFacturaFound') + '</b><br> ' + this.$t('notFacturaFoundDesc'))
          }
        } else {
          cerrarPestana(ventanaPdf)
          this.$emit('alert', '<b>' + this.$t('errorDefault') + '</b><br> ' + mensajeErrorWs(response))
        }
      }).catch(error => {
        console.error(error)
        cerrarPestana(ventanaPdf)
        this.$emit('alert', '<b>' + this.$t('errorDefault') + '</b><br> ' + mensajeErrorWs(error))
      }).finally(() => {
        this.fEventLoading()
      })
    },
    /**
     * Metodo para descargar en CSV
     */
    fDescargarFacturaExcel(factura) {
      let dFacturaTemp = String(Number(factura.numped.substr(factura.numped.length - 6)))
      let serieFactura
      let secuenciaFactura

      if (factura.numped !== null) {
        dFacturaTemp = factura.numero
        serieFactura = String(factura.numped.substring(0, factura.numped.length - 6))
        secuenciaFactura = Number(factura.numped.substr(factura.numped.length - 6))
      }
      this.dFacturaTemp = dFacturaTemp
      const date = this.$moment(factura.fechaPed, this.dDateFormats.default).toDate()
      const yyyy = date.getFullYear()

      const payload = {
        tira: this.$store.getters.getAutenticacion.tira,
        empresa: String(this.$store.getters.getAutenticacion.empresa),
        tipoEmpresa: '0',
        pdfSn: 'S',
        help: 'N',
        serieFactura: serieFactura,
        secuenciaFactura: secuenciaFactura,
        cliente: String(factura.codCli),
        ejercicio: yyyy
      }
      SrvImpresion.imprimirFacturaCSV(payload).then(response => {
        if (response.data.statusCode === '200') {
          const csvContent = atob(response.data.dataRes.File)
          this.downloadCSV(csvContent, factura.numped)
        } else {
          this.$emit('alert', '<b>carga role de portal</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
        }
      })
    },

    downloadCSV(csv, filename) {
      // CSV file
      var uint8 = new Uint8Array(csv.length)
      for (var i = 0; i < uint8.length; i++) {
        uint8[i] = csv.charCodeAt(i)
      }
      const csvFile = new Blob([uint8], {
        encoding: 'UTF-16',
        type: 'text/csv;charset=UTF-16'
      })
      // Download link
      const downloadLink = document.createElement('a')
      // File name
      downloadLink.download = filename + '.csv'
      // Create a link to the file
      downloadLink.href = window.URL.createObjectURL(csvFile)
      // Hide download link
      downloadLink.style.display = 'none'
      // Add the link to DOM
      document.body.appendChild(downloadLink)
      // Click download link
      downloadLink.click()
    },
    fOpenUrls(datos) {
      datos.forEach(item => {
        if (item.url && item.url !== '') {
          window.open(item.url, '_blank')
        }
      })
    },
    fAlert(msg) {
      this.$emit('alert', msg)
    },
    fDescargarVarios() {
      if (!this.dSelected || this.dSelected.length === 0) {
        return
      }

      this.fEventLoading();
      const auth = this.$store.getters.getAutenticacion;
      const isZip = this.dSelected.length > 10 ? 'S' : 'N';

      // Procesar cada elemento seleccionado
      const lista = this.dSelected.map(element => {
        // Determinar serie y factura
        let serieTemp = element.numped.substring(0, element.numped.length - 6);
        let dFacturaTemp = String(Number(element.numped.substr(element.numped.length - 6)));

        if (element.serie && element.secuencia) {
          serieTemp = element.serie;
          dFacturaTemp = element.secuencia;
        } else if (element.numero) {
          dFacturaTemp = element.numero;
        }

        const fechaFormateada = this.formatDate(element.fechaPed);
        const aux = {
          tira: auth.tira,
          empresa: auth.empresa,
          tipoEmpresa: '0',
          pdfSn: isZip,
          rpteIni: element.representante,
          rpteFin: element.representante,
          fechaIni: fechaFormateada,
          fechaFin: fechaFormateada,
          clteIni: element.codCli,
          clteFin: element.codCli,
          factFin: dFacturaTemp,
          factIni: dFacturaTemp,
          factName: element.numped
        };

        // Agregar series si existe y es válida
        if (serieTemp && serieTemp !== 'null' && serieTemp.length > 0) {
          aux.series = [{ serie: serieTemp }];
        }

        return aux;
      });

      // Descargar según cantidad
      if (isZip === 'N') {
        // Descargar PDFs individuales
        Promise.all(lista.map(payload =>
          SrvImpresion.getURLFacturas(payload)
            .then(response => {
              if (this.fRespuestaCorrecta(response)) {
                window.open(response.data.url, '_blank');
              } else {
                this.$emit('alert', `<b>${this.$t('pdfNotFound')}</b><br>${this.$t('pdfNotFoundDesc')}`);
              }
            })
            .catch(error => {
              console.error(error);
              this.$emit('alert', `<b>${this.$t('responseFail')}</b><br>${this.$t('responseFailDesc')}`);
            })
        )).finally(() => {
          this.fEventLoading();
          this.dSelected = [];
          this.dSelectedAll = false;
        });
      } else {
        // Descargar ZIP
        SrvImpresion.getZipFacturas(lista)
          .then(response => {
            if (this.fRespuestaCorrecta(response)) {
              downloadZip('facturas.zip', response.data);
            } else {
              this.$emit('alert', `<b>${this.$t('zipNotFound')}</b><br>${this.$t('zipNotFoundDesc')}`);
            }
          })
          .catch(error => {
            console.error(error);
            this.$emit('alert', `<b>${this.$t('responseFail')}</b><br>${this.$t('responseFailDesc')}`);
          })
          .finally(() => {
            this.fEventLoading();
            this.dSelected = [];
            this.dSelectedAll = false;
          });
      }
    },
    fToggleAll() {
      if (this.dSelectedAll) {
        this.dSelected = []
        this.dSelectedAll = false
      } else {
        this.dSelected = this.facturas.slice()
        this.dSelectedAll = true
      }
    },
    fSelectSucursal(item) {
      this.dSelectSucursal.codigo = item.codigo
      this.dSelectSucursal.nombre = item.nombre
      //this.dUsuarioSeleccionado.sucursalClte = item.codigo
    },
    fClearSucursal() {
      this.dDataSucursal.disabled = true
      this.dSelectSucursal = {}
    },
    fLimitFechas() {
      if (this.pLimitDate.fechaIniLimit !== '' && this.pLimitDate.fechaIniLimit !== null) {
        this.dFechaMinIni = this.$moment(this.pLimitDate.fechaIniLimit, this.dDateFormats.years).format(this.dDateFormats.years)
      }
      if (this.pLimitDate.fechaFinLimit !== '' && this.pLimitDate.fechaFinLimit !== null) {
        this.dFechaMinFin = this.$moment(this.pLimitDate.fechaFinLimit, this.dDateFormats.years).format(this.dDateFormats.years)
      }
    },
    fNotEmpty(value) {
      let returnValue = false
      if (value !== undefined && value !== null && value !== '' && value) {
        returnValue = true
      }
      return returnValue
    },
    fRespuestaCorrecta(response) {
      let returnValue = false
      if (response.status === 200 && response.data.result !== 'ko' && (response || response.data !== undefined || response.data.dataRes.result !== undefined || response.data.dataRes.result !== null)) {
        returnValue = true
      }
      return returnValue
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.buttonBar .card__title {
  padding: 8px !important;
}

.buttonBarSearch .card__title {
  padding: 0px !important;
}

.buttonBarSearchTop .card__text {
  padding-top: 4px !important;
  padding-bottom: -10px !important;
}

.numberInputSpinnerInput .vnis__input {
  background: #ffffff !important;
  border: 0px !important;
  border-bottom: 1px solid #999999 !important;
}

.numberInputSpinnerButton .vnis__button {
  background: #ffffff !important;
  color: #000000 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Informes/ReimpresionFacturas/ShpReimpresionFacturas.vue